import React from 'react';

import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SubHeader } from '~/components/SubHeader';
import { Text } from '~/components/Text';
import { color } from '~/assets/styles/colors';

import MudarSenha from '~/components/AlterarSenha';

function AlterarSenha() {
	return (
		<Container fluid>
			<SubHeader
				breadcrumb={[
					{
						page: 'Alterar senha',
						link: '/client/alterar-senha',
					},
				]}
			/>

			<Row className="my-5 border-bottom pb-2">
				<Col md="9" className="d-flex aling-items-center">
					<Text size="large">Alterar senha</Text>
				</Col>
				<Col md="3" className="d-flex justify-content-end">
					<Link
						to="/client/dashboard"
						className="notranslate"
						style={{ color: `${color.blue}` }}>
						Voltar para home
					</Link>
				</Col>
			</Row>
			<Card>
				<CardBody>
					<MudarSenha />
				</CardBody>
			</Card>
		</Container>
	);
}

export default AlterarSenha;
